export enum RoutesKeys {
  ONBOARD = 'onboarding',
  LOGIN = 'login',
  REGISTER = 'register',
  VERIFICATION = 'verification',
  NOT_FOUND = 'not-found',
  HOME = 'home',
  FORGOT_PASSWORD = 'forgot-password',
  CREATE_NEW_PASSWORD = 'create-new-password',
  BUSINESS_SETTINGS = 'business-settings',
  INVITE = 'invite',
  CREATE_ACCOUNT = 'create-account',
  PROFILE_CREATED = 'profile-created',
  INVITE_EXISTING = 'invite-existing',
  MEMBERSHIP_SUCCESS = 'membership-success',
  INVITE_REFUSE = 'invite-refuse',
  REWARDS = 'rewards',
  ADD_POINTS = 'add-points',
  POINT_BALANCE = 'point-balance',
  POINT_BALANCE_LIST = 'point-balance-list',
  COUPONS = 'coupons',
  COUPONS_VIP = 'coupons-vip',
  ACCOUNT_SETTINGS = 'account-settings',
  CHANGE_PASSWORD = 'change-password',
  DELETE_ACCOUNT = 'deactivate-account',
  ACCOUNT_DELETED = 'account-deleted',
  ACCOUNT_MIGRATION = 'account-migration',
  EXPIRED_INVITE = 'expired-invite',
  FAQ = 'faq',
}
